import { render, staticRenderFns } from "./MigrationWarning.vue?vue&type=template&id=db6a592c&scoped=true&"
import script from "./MigrationWarning.vue?vue&type=script&lang=js&"
export * from "./MigrationWarning.vue?vue&type=script&lang=js&"
import style0 from "./MigrationWarning.vue?vue&type=style&index=0&id=db6a592c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6a592c",
  null
  
)

export default component.exports